import { render, staticRenderFns } from "./ad-list.vue?vue&type=template&id=10ca0afd"
import script from "./ad-list.vue?vue&type=script&lang=js"
export * from "./ad-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports